const getUpgradeToClubState = (state): any => state.account.upgradeToClub

const getProvinces = (state): any => getUpgradeToClubState(state).provinces
const getIsProvincesPopulated = (state): any => getUpgradeToClubState(state).isProvincesPopulated

const getIsProvincesLoading = (state): any => getUpgradeToClubState(state).isProvincesLoading
const getIsUpgradeLoading = (state): any => getUpgradeToClubState(state).isPostUpgradeToClubLoading
const getPostUpgradeToClubError = (state): any =>
  getUpgradeToClubState(state).postUpgradeToClubError

export default {
  getProvinces,
  getIsProvincesLoading,
  getIsProvincesPopulated,
  getIsUpgradeLoading,
  getPostUpgradeToClubError,
}
